import { IAddressSuggestion } from "@nx-ng/types";
import { AddressSearchResult } from "../client/src";

export function toLocalAddressSuggestion(responseItem: AddressSearchResult): IAddressSuggestion | undefined {
  if (responseItem.value && responseItem.items && responseItem.label && typeof responseItem.container !== 'undefined') {
    return {
      id: responseItem.value,
      containerSize: responseItem.items,
      label: responseItem.label,
      isContainer: responseItem.container
    }
  }
  return undefined;
}
